import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    ventacarro: null,
    propietario: null,
    accesorios: null,
    fechacambioaceite: null,
    cambioaceite: null,
    consideracarro: null,
    recibecarro: null,
    estado_revision: null

};
const mutations = {
    updateField,
    updateForm: (state, payload) => {
        if (payload.length !== 0) {
            Object.keys(payload).forEach(key => {
                state[key] = payload[key];
            });
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
